<template>
  <!-- 审批历史 -->
  <j-modal :title="title" :width="800" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container>
        <a-row style="position:relative">
          <div class="block">
            <a-timeline>
              <a-timeline-item v-for="(item,index ) in approvalHistoryList" :key="index">
                <p style="font-weight: 700;">{{item.operateType==0?$t('审批'):item.operateType==1?$t('提交'):item.operateType==2?$t('撤销'):''}}</p>
                <a-card :body-style="{ padding: '10px' }">
                  <label v-if="item.createBy" style="font-weight: normal;margin-right: 30px;">{{ $t('操作人') }}： {{item.createBy}}</label>
                  <label style="font-weight: normal">{{ $t('操作时间') }}： </label>
                  <label style="color:#8a909c;font-weight: normal">{{item.createTime}}</label>
                  <p>
                    <template v-if="item.operateType==0">
                      <a-tag color="green" v-if="item.isAgree === 1">
                        <span>{{ $t('通过') }}：</span>{{item.approvalDescription}}
                      </a-tag>
                      <a-tag color="red" v-if="item.isAgree === 0">{{ $t('驳回') }}： {{item.approvalDescription}}</a-tag>
                    </template>
                    <a-tag color="blue" v-if="item.operateType==1">{{ $t('申请原因') }}： {{item.applyDescription}}</a-tag>
                  </p>
                </a-card>
              </a-timeline-item>
            </a-timeline>
          </div>
        </a-row>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import {
    PhoneNumberPattern
  } from '@/utils/regPattern'
  export default {
    name: 'handleModal',
    components: {},
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        url: {
          historyList:"/jeecg-charge/meter/wechatUserApplyRecord/list",
        },
        approvalHistoryList: []
      }
    },
    computed: {
      validatorRules() {
        return {
          isAgree: [{
            required: true,
            message: this.$t('请选择审批意见'),
            trigger: 'blur'
          }],
          approvalDescription: [{
            required: true,
            message: this.$t('请输入审批描述'),
            trigger: 'blur'
          }],
        };
      },
    },
    methods: {
      init(row) {
        this.visible = true;
        this.disableSubmit = true;
        this.title = this.$t('审批历史');
        // this.model = JSON.parse(JSON.stringify(row));
        this.getapprovalHistoryList(row.id);
      },
      getapprovalHistoryList(id){
        getAction(this.url.historyList,{wechatUserApplyId:id}).then(res=>{
          if(res.success){
            this.approvalHistoryList = res.result;
          }
        })
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel() {
        this.close()
      },
    }
  }
</script>